import { useState } from "react";
import imgLogo from "@/assets/ig-logo-2.png";
import useNavigateWithParams from "@/hooks/use-utm-params";

export function DeliveryPage() {
  const [email, setEmail] = useState("");
  const [isError, setIsError] = useState(false);

  const navigate = useNavigateWithParams();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !validateEmail(email)) {
      setIsError(true);
      return;
    }

    navigate("/delivery/search", { email });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setIsError(false);
  };

  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  return (
    <div className="min-h-screen flex flex-col bg-neutral-900 text-neutral-100">
      <header className="bg-black border-b border-neutral-700 py-4">
        <div className="container max-w-[450px] mx-auto px-6">
          <div className="flex items-center justify-center">
            <img src={imgLogo} alt="Logo" className="w-[60px]" />
          </div>
        </div>
      </header>

      <div className="flex-1 container max-w-[450px] mx-auto px-6 py-8">
        <div className="bg-neutral-800 rounded-xl border border-neutral-700 p-6 mb-6">
          <div
            className="flex items-center justify-center gap-2 p-2 rounded-full mb-4 mx-auto w-fit"
            style={{
              backgroundImage:
                "linear-gradient(90deg, rgba(237, 127, 0, 1) 0%, rgba(255, 90, 53, 1) 100%)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-white"
            >
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span className="text-white font-medium text-sm">
              Compra aprobada
            </span>
          </div>

          <h1 className="text-2xl font-bold text-center mb-2 text-white">
            Accede a tu cuenta
          </h1>

          <p className="text-neutral-300 text-sm text-center mb-6">
            Ingresa el correo electrónico utilizado en la compra para acceder a
            tu contenido
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-neutral-300 mb-1"
              >
                Correo electrónico
              </label>
              <input
                type="email"
                id="email"
                placeholder="tu.correo@ejemplo.com"
                required
                name="email"
                value={email}
                onChange={handleInputChange}
                className={`w-full px-4 py-3 rounded-lg border bg-neutral-700 text-white placeholder-neutral-400 ${
                  isError
                    ? "border-red-500 focus:ring-red-500"
                    : "border-neutral-600 focus:ring-orange-500"
                } focus:border-transparent focus:outline-none focus:ring-2`}
              />
              {isError && (
                <p className="mt-1 text-sm text-red-400">
                  Por favor, ingresa un correo electrónico válido.
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full py-3 px-4 rounded-lg font-semibold text-white transition-all hover:opacity-90 focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 focus:outline-none focus:ring-offset-neutral-800"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, rgba(237, 127, 0, 1), rgba(255, 90, 53, 1))",
              }}
            >
              Acceder al contenido
            </button>
          </form>
        </div>

        <div className="bg-neutral-800 rounded-xl border border-neutral-700 p-5">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-orange-500"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <div>
              <h3 className="font-medium text-sm text-neutral-200">
                ¿Primer acceso?
              </h3>
              <p className="text-neutral-400 text-xs mt-1">
                Ingresa el mismo correo electrónico utilizado en la compra. Un
                enlace de acceso permanente también fue enviado a tu correo.
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-neutral-800 py-4 border-t border-neutral-700">
        <div className="container max-w-[450px] mx-auto px-6">
          <p className="text-xs text-neutral-400 text-center">
            © {new Date().getFullYear()} Teagram. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}
